function initializeDeviceManagement() {
  console.log("Initializing device management...");

  const selectAll = document.getElementById("selectAllDevices");
  const deviceCheckboxes = document.querySelectorAll(".device-checkbox");
  const selectedCount = document.getElementById("selectedDevicesCount");
  const form = document.getElementById("testNotificationForm");

  console.log("Found elements:", {
    selectAll: !!selectAll,
    deviceCheckboxes: deviceCheckboxes.length,
    selectedCount: !!selectedCount,
    form: !!form,
  });

  // Only initialize if elements exist
  if (!form) {
    console.log("Form not found, skipping initialization");
    return;
  }

  // Select all functionality
  if (selectAll) {
    selectAll.addEventListener("change", function () {
      console.log("Select all toggled:", this.checked);
      deviceCheckboxes.forEach((cb) => (cb.checked = this.checked));
      updateSelectedCount();
    });
  }

  // Update count when individual checkboxes change
  deviceCheckboxes.forEach((cb) => {
    cb.addEventListener("change", updateSelectedCount);
  });

  function updateSelectedCount() {
    const count = document.querySelectorAll(".device-checkbox:checked").length;
    console.log("Selected devices count:", count);
    if (selectedCount) {
      selectedCount.textContent = `${count} пристроїв обрано`;
      if (count > 100) {
        selectedCount.classList.add("text-danger");
        selectedCount.textContent = `${count} пристроїв обрано (максимум 100)`;
      } else {
        selectedCount.classList.remove("text-danger");
      }
    }
  }

  // Initialize count on load
  updateSelectedCount();

  // Copy device ID to clipboard functionality
  const copyButtons = document.querySelectorAll(".copy-device-id");
  console.log("Found copy buttons:", copyButtons.length);

  copyButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const deviceId = this.dataset.deviceId;
      console.log("Copying device ID:", deviceId);

      navigator.clipboard
        .writeText(deviceId)
        .then(() => {
          const icon = this.querySelector("i");
          const originalClass = icon.className;

          // Show success feedback
          icon.className = "bi bi-check";
          this.classList.add("btn-success");
          this.classList.remove("btn-outline-secondary");

          // Reset after 2 seconds
          setTimeout(() => {
            icon.className = originalClass;
            this.classList.remove("btn-success");
            this.classList.add("btn-outline-secondary");
          }, 2000);

          console.log("Device ID copied successfully");
        })
        .catch((err) => {
          console.error("Failed to copy device ID:", err);
          alert("Не вдалося скопіювати токен");
        });
    });
  });

  // Add selected device IDs to form before submit
  form.addEventListener("submit", function (e) {
    console.log("Form submitting...");

    // Remove any previously added hidden inputs to avoid duplicates
    const existingHiddenInputs = form.querySelectorAll(
      'input[type="hidden"][name="device_ids[]"]'
    );
    console.log(
      "Removing existing hidden inputs:",
      existingHiddenInputs.length
    );
    existingHiddenInputs.forEach((input) => input.remove());

    const checked = document.querySelectorAll(".device-checkbox:checked");
    console.log("Checked devices:", checked.length);

    if (checked.length === 0) {
      e.preventDefault();
      alert("Будь ласка, оберіть хоча б один пристрій");
      return;
    }
    if (checked.length > 100) {
      e.preventDefault();
      alert("Максимум 100 пристроїв за раз");
      return;
    }

    // Add device IDs to form
    checked.forEach((cb) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "device_ids[]";
      input.value = cb.value;
      form.appendChild(input);
      console.log("Added device ID:", cb.value);
    });

    console.log("Form data being submitted:", new FormData(form));
  });
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
  console.log("DOMContentLoaded event fired");
  initializeDeviceManagement();
});

// Re-initialize on Turbolinks page load
document.addEventListener("turbolinks:load", function () {
  console.log("Turbolinks load event fired");
  initializeDeviceManagement();
});
